// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__2wzdz","tab":"ProcedureTabs_tab__3qeVJ"};